import { useMutation } from "services/Client";
import { PATIENT_NOTE_GET_MANY } from "services/Client/schemas/queries/patient_note";
import { useNotification } from "hooks";

export default function useCreatePatientNote(id, body) {
  const notification = useNotification();
  const { mutate } = useMutation({
    event: "patient.note.insert.one",
    variables: {
      object: { patientId: id, note: { data: { body } } },
    },
    update: (cache, { data: { insert_patient_note_one } }) => {
      const prevData = cache.readQuery({
        query: PATIENT_NOTE_GET_MANY,
        variables: { where: { patientId: { _eq: id } } },
      });
      const data = {
        patient_note: [
          insert_patient_note_one,
          ...prevData.patient_note,
        ],
      };
      cache.writeQuery({
        query: PATIENT_NOTE_GET_MANY,
        data,
        variables: { where: { patientId: { _eq: id } } },
      });
    },
    onCompleted: (data) => {
      notification.success({
        message: "Remarque Sauvegardée",
      });
    },
  });
  return mutate;
}
